import React from 'react';
import { Route, Redirect, RouteProps, RouteComponentProps } from 'react-router-dom';
import Notification from '../components/Ant/Notification';

import { APICore } from '../helpers/api/apiCore';
interface PrivateRouteProps {
    component: React.FunctionComponent<RouteProps>;
    roles?: string;
    requiredScopes?: string[];
}

/**
 * Private Route forces the authorization before the route can be accessed
 * @param {*} param0
 * @returns
 */
const PrivateRoute = ({ component: Component, roles, requiredScopes, ...rest }: PrivateRouteProps) => {
    const api = new APICore();    
    return (
        
        <Route
            {...rest}
            render={(props: RouteComponentProps) => {
    

                if (api.isUserAuthenticated() === false) {                   
                    // not logged in so redirect to login page with the return url
                    return (
                        <Redirect
                            to={{
                                pathname: '/auth/login',
                                state: { from: props['location'] },
                            }}
                        />
                    );
                }

                if (api.isUserAllowed(requiredScopes) === false) {
                    
                    // not logged in so redirect to login page with the return url
                    return (
                        
                          
                          <Notification title="عدم دسترسی" message="شما مجوز مشاهده و استفاده از این صفحه را ندارید"/>
                        
                    //messageApi.info('Hello, Ant Design!')

                    );
                    
                    // return;
                }                    
                                
                // authorised so return component
                return <Component {...props} />;
            }}
        />
    );
};

export default PrivateRoute;
